import app from 'flarum/common/app';
import { api } from './api';

/**
 * Conteúdo das páginas do marketplace embutido no payload do boot pelo
 * `Ramon\Marketplace\Frontend\PreloadPageData` (server-side).
 *
 * O backend roda o MESMO controller que o front chamaria e injeta o envelope
 * JSON inteiro em `app.data.marketplacePreload[chave]`. Aqui só consumimos.
 */

/** Consumo é ÚNICO: o preload vale para a montagem que veio junto com o HTML. */
export function takePreload(key) {
  try {
    const bag = app?.data?.marketplacePreload;
    if (!bag || typeof bag !== 'object') return null;
    const value = bag[key];
    if (value === undefined || value === null) return null;

    // Apaga na leitura: navegar no SPA e voltar para a página busca dados
    // frescos da API em vez de repintar o snapshot do boot (que seria cache
    // velho). O preload é sempre tão fresco quanto o HTML que o entregou.
    delete bag[key];
    return value;
  } catch {
    return null;
  }
}

/**
 * Mesmo contrato de `api('GET', path)` — devolve uma Promise com o envelope da
 * API — mas resolve na hora com o preload do boot quando ele existe, sem
 * round-trip. Sem preload (navegação SPA, revisita, falha no servidor), cai no
 * fetch normal: o call site não muda.
 */
export function apiPreload(key, path) {
  const pre = takePreload(key);
  return pre !== null ? Promise.resolve(pre) : api('GET', path);
}

/**
 * `true` quando a chave veio no boot — para o componente decidir se pinta
 * direto (sem estado de "carregando") antes de qualquer await.
 */
export function hasPreload(key) {
  try {
    const bag = app?.data?.marketplacePreload;
    return !!bag && typeof bag === 'object' && bag[key] !== undefined && bag[key] !== null;
  } catch {
    return false;
  }
}
flarum.reg.add('ramon-marketplace', 'common/utils/preload', { takePreload: takePreload,apiPreload: apiPreload,hasPreload: hasPreload, });